/* Match the app-injected COD button inside this draft's cart only. */
(()=>{let drawer,drawerObserver;function styleButton(){document.querySelectorAll('cart-drawer .es-popup-button').forEach(b=>{if(b.style.getPropertyValue('background')!=='rgb(194, 20, 53)')b.style.setProperty('background','#c21435','important');if(b.style.getPropertyValue('border-color')!=='rgb(194, 20, 53)')b.style.setProperty('border-color','#c21435','important');});}function bindDrawer(){const next=document.querySelector('cart-drawer');if(!next)return;if(next===drawer){styleButton();return;}drawerObserver?.disconnect();drawer=next;styleButton();drawerObserver=new MutationObserver(styleButton);drawerObserver.observe(drawer,{childList:true,subtree:true,attributes:true,attributeFilter:['style']});}function init(){bindDrawer();new MutationObserver(bindDrawer).observe(document.documentElement,{childList:true,subtree:true});document.addEventListener('cart:refresh',bindDrawer);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();})();

// Physical arrow names match the RTL gallery, including editor/quick-add inserts.
(()=>{function rtlGalleryLabels(root){root.querySelectorAll('media-gallery button[name="previous"],media-gallery button[name="next"]').forEach(button=>{button.setAttribute('aria-label',button.name==='previous'?'السابق':'التالي');});}function init(){rtlGalleryLabels(document);new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)rtlGalleryLabels(node);}))).observe(document.body,{childList:true,subtree:true});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();})();

// Product-specific WhatsApp ordering; product and option names come from Shopify's current page data.
(()=>{
  function init(){
    const source=document.getElementById('filtary-wa-product');
    if(!source)return;
    const product=JSON.parse(source.textContent);
    function refresh(){
      document.querySelectorAll('#flt-form .hero button[type="submit"],main product-form[data-main="true"] .product-form__submit[type="submit"]').forEach(button=>{
        const host=button.closest('product-form')||button;
        let link=host._filtaryWaLink;
        if(!link||!link.isConnected){
          link=document.createElement('a');
          link.className='flt-wa-order';
          link.target='_blank';
          link.rel='noopener';
          link.innerHTML='<span aria-hidden="true">'+(document.querySelector('#whatsapp-chat svg')?.outerHTML||'')+'</span>اطلب عبر واتساب';
          host.after(link);
          host._filtaryWaLink=link;
        }
        function update(){
          const form=button.closest('form');
          const id=(form?.querySelector('[name="id"]:checked')||form?.querySelector('[name="id"]'))?.value;
          const variant=product.variants.find(v=>String(v.id)===String(id));
          const quantity=(form?.querySelector('[name="quantity"]')||button.closest('product-info')?.querySelector('[name="quantity"]'))?.value||'1';
          const message=[
            'أريد طلب: '+product.title,
            variant&&variant.title!=='Default Title'?'الخيار: '+variant.title:'',
            'الكمية: '+quantity
          ].filter(Boolean).join('\n');
          link.href='https://wa.me/15557358788?text='+encodeURIComponent(message);
        }
        update();
        link._filtaryUpdate=update;
        if(!link.dataset.bound){
          link.dataset.bound='1';
          link.addEventListener('click',()=>link._filtaryUpdate?.());
        }
      });
    }
    refresh();
    document.addEventListener('change',refresh);
    document.addEventListener('input',refresh);
    document.addEventListener('shopify:section:load',refresh);
    new MutationObserver(records=>{
      if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1&&!n.matches('.flt-wa-order'))))refresh();
    }).observe(document.querySelector('main'),{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

// Contact links stay general, even when an unrelated product is already in the cart.
// The product-order links above retain their own selected product/variant message.
(()=>{
  const phone='15557358788';
  const question='مرحباً، عندي بعض الأسئلة عن منتجات فلتري.';
  function setContactMessage(link){
    if(link.classList.contains('flt-wa-order'))return;
    let url;
    try{url=new URL(link.href,location.href);}catch{return;}
    const isShortLink=url.hostname==='wa.me'&&url.pathname.replace(/\D/g,'')===phone;
    const isApiLink=url.hostname==='api.whatsapp.com'&&/^\/send\/?$/.test(url.pathname)&&url.searchParams.get('phone')?.replace(/\D/g,'')===phone;
    if(!isShortLink&&!isApiLink)return;
    if(url.searchParams.get('text')===question)return;
    url.searchParams.set('text',question);
    link.href=url.href;
  }
  function updateLinks(root){
    if(root.matches?.('a[href]'))setContactMessage(root);
    root.querySelectorAll?.('a[href*="wa.me/"],a[href*="api.whatsapp.com/send"]').forEach(setContactMessage);
  }
  function init(){
    updateLinks(document);
    new MutationObserver(records=>records.forEach(record=>{
      if(record.type==='attributes')updateLinks(record.target);
      else record.addedNodes.forEach(node=>{if(node.nodeType===1)updateLinks(node);});
    })).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
    document.addEventListener('click',event=>{
      const link=event.target.closest?.('a[href]');
      if(link)setContactMessage(link);
    },true);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
